import { motion } from "framer-motion";
import { GraffitiTag } from "@/components/GraffitiTag";
import { Scramble } from "@/components/Scramble";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Beam = () => (
  <motion.div
    aria-hidden="true"
    initial={{ scaleX: 0, opacity: 0 }}
    whileInView={{ scaleX: 1, opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
    className="absolute top-0 inset-x-0 h-[2px] origin-center bg-gradient-to-r from-transparent via-gold to-transparent shadow-[0_0_20px_rgba(212,175,55,0.65)]"
  />
);

export const SectionHeading = ({ overline, title, center = false, testId, tag }) => (
  <div className={`mb-12 lg:mb-16 ${center ? "text-center" : ""}`} data-testid={testId}>
    {overline && (
      <Reveal>
        <p className="overline-label mb-4">
          <Scramble text={overline} />
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <div className="relative inline-block">
        {tag && (
          <GraffitiTag
            testId={`${testId}-tag`}
            className="absolute -top-6 sm:-top-8 -right-1 sm:-right-6 z-10 text-lg sm:text-2xl lg:text-3xl"
            rotate={-4}
          >
            {tag}
          </GraffitiTag>
        )}
        <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white max-w-3xl ${center ? "mx-auto" : ""}`}>
          {title.split(" ").map((word, wi) => (
            <motion.span
              key={wi}
              className="inline-block whitespace-nowrap will-change-transform mr-[0.28em]"
              initial={{ x: -70, opacity: 0, filter: "blur(5px)" }}
              whileInView={{ x: 0, opacity: 1, filter: "blur(0px)" }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: 0.05 + wi * 0.13, duration: 1.25, ease: [0.18, 1.28, 0.36, 1] }}
            >
              <Scramble text={word} speed={48} frames={22} />
            </motion.span>
          ))}
        </h2>
      </div>
    </Reveal>
    <Reveal delay={0.16}>
      <div className={`mt-5 h-px w-24 bg-gradient-to-r from-gold to-champagne ${center ? "mx-auto" : ""}`} />
    </Reveal>
  </div>
);
